if (!customElements.get('adev-recently-viewed')) {
    customElements.define('adev-recently-viewed', class adevRecentlyViewed extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.observer = new window.IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        this.renderRecentlyViewed();
                        this.observer.disconnect();
                    }
                });
            }, { rootMargin: '0px', threshold: 0 });
            this.observer.observe(this);
        }


        disconnectedCallback() {
            if (this.observer) this.observer.disconnect();
        }

        getRecentlyViewed() {
            if (!window.Cookies) return [];
            const cookie = window.Cookies.get('adev_recently_viewed');
            if (!cookie) return [];
            try {
                const arr = JSON.parse(cookie);
                return Array.isArray(arr) ? arr : [];
            } catch {
                return [];
            }
        }

        async renderRecentlyViewed() {
            const handles = this.getRecentlyViewed();
            if (!handles.length) return;

            this.classList.add('is--ready');

            const productsEl = this.querySelector('[data-adev-recently-viewed="products"]');
            if (!productsEl) return;

            try {
                const fetches = handles.map(handle =>
                    fetch(`/products/${encodeURIComponent(handle)}?section_id=adev-recently-viewed`)
                        .then(res => res.ok ? res.text() : null)
                        .catch(() => null)
                );
                const htmlArr = await Promise.all(fetches);
                const fragments = htmlArr
                    .filter(Boolean)
                    .map(html => {
                        const temp = document.createElement('div');
                        temp.innerHTML = html;
                        const exportEl = temp.querySelector('[data-adev-recently-viewed="export"]');
                        return exportEl ? exportEl.innerHTML : '';
                    });
                productsEl.innerHTML = fragments.join('');
            } catch (e) {
                // fail silently
            }
        }

        // ...existing code...

    });
}